import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { NgxSpinnerModule } from 'ngx-spinner';

import {
  ToolbarModule,
  TabsModule,
  FilterModule,
  DetailsModule,
  PaginationModule,
  SettingsModule,
  TableModule,
  CustomModalModule,
  ViewTableModule,
} from 'beyond-util';
import { PregledKupacaComponent } from './pregled-kupaca.component';

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TabsModule,
    FilterModule,
    CustomModalModule,
    DetailsModule,
    PaginationModule,
    ViewTableModule,
    SettingsModule,
    ToolbarModule,
    TableModule,
    NgxSpinnerModule,
  ],
  declarations: [PregledKupacaComponent],
  entryComponents: [PregledKupacaComponent],
  exports: [PregledKupacaComponent],
})
export class PregledKupacaModule {}



// WEBPACK FOOTER //
// ./src/app/pages/sifarnici/pregled-kupaca/pregled-kupaca.module.ts